module.exports = __webpack_public_path__ + "static/media/Golden-Tutors-logo.22773ea8.png";